<template>
  <div id="app" :style="baseColor">
    <layout-component v-if="showBaseLayout" />
    <novo-usuario-layout v-else-if="hasToken && newUser"></novo-usuario-layout>
    <public-layout-component v-else></public-layout-component>
  </div>
</template>

<script>
import LayoutComponent from "./layouts/base-layout.vue";
import { publicoRotas } from "./router/publico.rotas";
import PublicLayoutComponent from "./layouts/public-layout.vue";
import NovoUsuarioLayout from "./layouts/novo-usuario-layout.vue";
import { isNewUser, store, updateToken } from "@/store";
import {
  generateAxiosCancelToken,
  requestCancelSource,
} from "./services/mainService";
import { UtilsTS } from "./utilsts";

import menuData from "@/assets/menu.json";

import { setarAmbiente } from '@/store'
import { limparTodasStoresProtocolos } from './stores/StoreProtocolosProcessos';

export default {
  mixins: [UtilsTS],
  components: {
    LayoutComponent,
    PublicLayoutComponent,
    NovoUsuarioLayout,
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  computed: {
    baseColor() {
      return {
        "--baseColor": this.getBaseColor(),
      };
    },
    forceQuit() {
      return store.forceQuit;
    },
    hasToken() {
      return (
        store.token !== false &&
        store.cpf !== "" &&
        (store.primeiroAcesso == "S" || store.primeiroAcesso == "N")
      );
    },
    newUser() {
      return isNewUser();
    },
    showBaseLayout() {
      const podeUsarBase = store.nextStep !== "confirmar-contato";
      return this.hasToken && !this.newUser && podeUsarBase;
    },
  },
  watch: {
    forceQuit(newVal, oldVal) {
      if (newVal === true) {
        requestCancelSource.cancel();
        generateAxiosCancelToken();
        limparTodasStoresProtocolos();
        let user = menuData.find((m) => {
          return m.title == this.capitalize(store.nomeUsuario);
        });
        if (user) user.title = "__USER__"
        updateToken(false, "", "");
        store.forceQuit = false;
        this.$toast.clear();
        //Caso a rota não seja a da tela de login, redireciona para ela
        if (this.$router.currentRoute.path !== "/") {
          this.$router.push("/");
        }
      }
    },
  },
  methods: {
    formatData(data) {
      return new Date(data).toLocaleDateString("pt-br");
    },
    onWindowResize() {
      store.isLowerResolution =
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) <= 992;
    },
  },
  beforeCreate() {
    setarAmbiente()
  },

  async mounted() {
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();
    if (store.token) {
      if (store.primeiroAcesso === "S") {
        this.$router.push("/seguranca-administracao/trocar-senha");
      }
    } else {
      if (
        !publicoRotas.some(
          (route) => route.path === this.$router.currentRoute.path
        )
      ) {
        this.$router.push("/");
      }
    }
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  min-width: 340px;
}

#app h4 {
  text-align: left;
  margin-left: 30px;
  padding-top: 50px;
}

h4 .main-icon {
  margin-right: 10px;
  color: var(--gray-dark);
}

.alert-error {
  margin: 3px 10px 3px 10px;
  padding: 0.5rem 1.25rem !important;
  position: absolute !important;
  right: 1rem !important;
}

.alert-error svg {
  margin-right: 10px;
}

.loading-text {
  margin-left: 10px;
}

.table td,
.table th {
  vertical-align: middle !important;
}

.b-table-sticky-header,
.table-responsive,
[class*="table-responsive-"] {
  margin-bottom: 0px !important;
}

.actions-text {
  cursor: pointer;
}

.actions-text:hover {
  text-shadow: 0px 0px 1px #2c3e50;
}

.actions-icon {
  border-top: #aaa dotted 1px;
  display: flex;
  justify-content: space-around;
  padding-top: 2px;
  margin-top: 3px;
}

/* estes são usados nos index dos CRUDs, para os botões de ação */
.min15rem.col-actions {
  min-width: 15rem;
}

.min7rem.col-actions {
  min-width: 7rem;
}

.min20rem.col-actions {
  min-width: 20rem;
}
.min4rem {
  min-width: 4rem;
}

.max3rem {
  max-width: 3rem;
}
.max15rem {
  max-width: 15rem;
}

.actions-icons {
  display: inline-flex;
  font-size: 16px;
  flex-wrap: wrap;
  gap: 18px;
}

.actions-icon span svg {
  font-size: 14px;
  cursor: pointer;
}

/* FIM estes são usados nos index dos CRUDs, para os botões de ação */

.current-progress {
  font-size: 12px;
  color: white;
}

.up-data {
  margin-bottom: 20px;
  padding-top: 40px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  font-size: 15px;
}

.up-data .col > :first-child {
  font-weight: bold;
}

.up-data .col > :nth-child(2) {
  margin-left: 5px;
}

.filename {
  font-size: 12px;
  white-space: nowrap;
}

#app /deep/ .align-middle {
  vertical-align: middle;
}

.titulo-sagres {
  line-height: 40px;
}

@media screen and (min-width: 576px) {
  .titulo-mobile {
    line-height: 40px;
  }
}

.texto-botao {
  display: block;
  font-size: 0.75rem;
}

/* deixar o texto de todas as tabs preto */
ul.nav.nav-tabs > li.nav-item > a {
  color: var(--dark);
}

/* quebrar palavras longas nas datatables */
table.b-table div {
  word-break: break-all;
}

/* trocar cor dos placeholders de texto */
input.form-control::placeholder {
  color: #ced4da;
}

/**Classes para controlar quebra de palavras nas datatables */
th.quebrarPorLetra div,
td.quebrarPorLetra div {
  word-break: break-all;
}

th.quebrarPorPalavra div,
td.quebrarPorPalavra div {
  word-break: break-word;
}

th.quebrarPorPalavraHard div,
td.quebrarPorPalavraHard div {
  word-break: normal;
}

th.naoQuebrar div,
td.naoQuebrar div {
  word-break: keep-all;
}

/** botões menores que o mínimo do bootstrap, geralmente para usar dentro de datatables */
button.extra-small {
  padding: 0.1rem 0.25rem;
}

/** permite que componentes como multiselect e b-calendar ultrapassem as dimensões de b-tables, se estiverem dentro delas */
div.overflowme {
  overflow: visible;
}

/** evita quebra de multiselect, quando fechado, devido a texto muito longo */
span.multiselect__placeholder {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/**corrige dropdowns desabilitados que mudam de cor ao ser validados */
select.custom-select:disabled.valid,
select.custom-select:disabled.is-valid,
select.custom-select:disabled.invalid,
select.custom-select:disabled.is-invalid {
  background: #e9ecef !important;
  border-color: #ced4da;
}

.wrapper-multiselect-sagres .multiselect {
  width: 100%;
  max-width: 100%;
}

.wrapper-multiselect-sagres .multiselect__tags {
  border: #ced4da solid 1px !important;
  border-radius: 3px !important;
}

.wrapper-multiselect-sagres .multiselect__option {
  padding: 6px !important;
  min-height: 0;
  font-size: 16px;
}

.wrapper-multiselect-sagres .multiselect__option--selected {
  color: #495057 !important;
  background: #fff;
  font-weight: 400;
}

.wrapper-multiselect-sagres .multiselect__content-wrapper {
  border: 1px solid #ced4da;
  max-height: 200px !important;
}

.wrapper-multiselect-sagres .multiselect__option--highlight {
  background: #007bff !important;
  color: #fff !important;
}

.wrapper-multiselect-sagres .multiselect__input,
.multiselect__single {
  background-color: #fff !important;
  color: #495057 !important;
}

.wrapper-multiselect-sagres .multiselect__input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #495057 !important;
}

.wrapper-multiselect-sagres .multiselect__input::active {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

.wrapper-multiselect-sagres .multiselect__tags {
  background-color: #fff;
  color: #495057 !important;
  border-radius: 2px;
}

.wrapper-multiselect-sagres .multiselect__select:before {
  color: #495057 !important;
  border-color: #495057 transparent transparent !important;
}

.wrapper-multiselect-sagres .multiselect {
  z-index: 2;
}

.wrapper-multiselect-sagres .multiselect__placeholder {
  color: #495057;
  font-weight: 400;
  font-size: 1rem;
}

.wrapper-multiselect-sagres .multiselect__single {
  cursor: pointer;
}

.wrapper-multiselect-sagres .multiselect__input,
.wrapper-multiselect-sagres .multiselect__single {
  vertical-align: initial;
}

.wrapper-multiselect-sagres .multiselect--disabled .multiselect__tags,
.wrapper-multiselect-sagres .multiselect--disabled .multiselect__tags span {
  color: #6c757d !important;
}

.wrapper-multiselect-sagres .multiselect--disabled .multiselect__select {
  background: #fff !important;
}

/** 
Classe que retira o cabeçalho de uma b-table
*/
.no-header-lines thead {
  display: none;
}

/**permite que a coluna de ações fique 100% vertical */
@media screen and (min-width: 1200px) and (max-width: 1350px) {
  div#consultarldiwrapper .min20rem.col-actions {
    min-width: auto;
  }

  .actions-icons.lgvert {
    display: flex;
    flex-direction: column;
  }
}

/**permite que a coluna de ações fique 100% vertical */
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  .actions-icons.lgvert2icones {
    display: flex;
    flex-direction: column;
  }
}

/** propriedades acima do breakpoint xs (sm, md, lg, xl) */
@media screen and (min-width: 576px) {
  /**usado para colunas pequenas, como a Ver Itens na edição de licitações */
  .w7rem {
    width: 7rem;
    max-width: 7rem;
  }
}

@media screen and (min-width: 992px) {
  .w7remLg {
    width: 7rem;
    max-width: 7rem;
  }
  .text-left-lg {
    text-align: left !important;
  }
}

@media screen and (max-width: 576px) {
  div#consultarldiwrapper .min20rem.col-actions {
    min-width: auto;
  }
}

/** Formata radiogroup buttons */
div[role="radiogroup"] label.btn.btn-secondary {
  background-color: rgba(0, 0, 0, 0.03);
  color: #545b62;
}

div[role="radiogroup"] label.btn.btn-secondary.active {
  background-color: rgb(108, 117, 125);
}

/** use para criar um botão pequeno, menor que o size="sm" */
button.btn.btn-tiny {
    padding: 0.1rem 0.3rem;
    font-size: 0.8rem;
    line-height: 1;
}
</style>
